import type { LaneId } from "@fate-kingdom/engine";

import { AlphaGameIcon } from "../icons/AlphaGameIcon";

export interface AlphaCombatPresentationState {
  readonly sourceLaneId: LaneId;
  readonly targetLaneId: LaneId;
  readonly kind: "Direct" | "Flank";
  readonly attack: number;
  readonly guard: number;
  readonly damage: number;
  readonly targetControlBefore: number;
  readonly targetControlAfter: number;
  readonly laneDefeated: boolean;
}

export function CombatPresentation({
  combat,
}: {
  readonly combat: AlphaCombatPresentationState | null;
}) {
  if (combat === null) return null;
  return (
    <div
      className={`alpha-combat-presentation ${combat.laneDefeated ? "is-lane-defeat" : ""}`}
      role="status"
      aria-label={`${combat.kind} Attack dealt ${String(combat.damage)} Control damage`}
    >
      <span className="alpha-combat-presentation__impact" aria-hidden="true" />
      <div>
        <small>{combat.kind} Attack</small>
        <b>
          <AlphaGameIcon name="attack" aria-hidden="true" /> {combat.attack}
          <i> versus </i>
          <AlphaGameIcon name="guard" aria-hidden="true" /> {combat.guard}
        </b>
        <strong>−{combat.damage} Control</strong>
        <span>
          {combat.targetControlBefore} → {combat.targetControlAfter}
        </span>
        {combat.laneDefeated ? <em>Lane claimed</em> : null}
      </div>
    </div>
  );
}
